import {
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemButtonProps,
  ListItemSecondaryAction,
  ListItemText,
  Skeleton,
} from '@mui/material';
import { CheckIcon, ChevronRightIcon } from '../../icons';
import { ReactNode } from 'react';

export type BrightyListItemProps<RootComponent extends React.ElementType = 'div'> =
  ListItemButtonProps<
    RootComponent,
    {
      title: ReactNode;
      subtitle?: ReactNode;
      button?: React.ReactNode;
      icon?: React.ReactNode;
      loading?: boolean;
      error?: string | null | undefined;
      checked?: boolean;
    }
  >;

export function BrightyListItem<RootComponent extends React.ElementType = 'div'>({
  title,
  subtitle,
  button,
  icon,
  loading,
  error,
  checked,
  ...props
}: BrightyListItemProps<RootComponent>) {
  const isButton = Boolean(props.onClick || props.href);
  let secondaryAction = button;
  if (typeof checked === 'undefined' && isButton) {
    secondaryAction = <ChevronRightIcon sx={{ width: '16px', height: '16px' }} />;
  }
  if (checked) {
    secondaryAction = <CheckIcon />;
  }
  secondaryAction = secondaryAction ? (
    <ListItemSecondaryAction>{secondaryAction}</ListItemSecondaryAction>
  ) : null;

  let content = (
    <>
      {icon ? <ListItemAvatar>{icon}</ListItemAvatar> : null}
      <ListItemText
        primary={title}
        secondary={loading ? <Skeleton /> : (error ?? subtitle)}
        slotProps={{
          primary: { variant: 'body1' },

          secondary: {
            variant: 'caption',
            color: error ? 'text.error' : 'text.secondary',
            sx: {
              wordBreak: 'break-word',
            },
          },
        }}
      />
      {secondaryAction}
    </>
  );
  if (isButton) {
    content = <ListItemButton {...props}>{content}</ListItemButton>;
  }

  return <ListItem disablePadding={isButton}>{content}</ListItem>;
}
